import type { ReactNode } from 'react'
import { Boxes, KeyRound, QrCode, UserRound, Users, Waypoints } from 'lucide-react'

// Единый источник пунктов основной навигации — используется и в TopBar (десктоп:
// текст + шорткат; промежуточная ширина 721–1080px: только иконки), и в нижней
// таб-навигации AppLayout (мобайл, только иконки). Иконки — lucide-react.
// ВАЖНО: при изменении набора синхронно правь ROUTE_SHORTCUTS в useKeyboardShortcuts.ts.
export interface NavItem {
  to: string
  label: string
  shortcut: string
  icon: ReactNode
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/profile', label: 'профиль', shortcut: 'p', icon: <UserRound aria-hidden /> },
  { to: '/vpn', label: 'vpn', shortcut: 'v', icon: <QrCode aria-hidden /> },
  { to: '/security', label: 'безопасность', shortcut: 'b', icon: <KeyRound aria-hidden /> },
  // Приглашения — раздел внутри «пользователей», своего пункта у них нет.
  { to: '/admin/users', label: 'пользователи', shortcut: 'u', icon: <Users aria-hidden /> },
  { to: '/admin/groups', label: 'группы', shortcut: 'g', icon: <Boxes aria-hidden /> },
  { to: '/admin/outbounds', label: 'аутбаунды', shortcut: 'o', icon: <Waypoints aria-hidden /> },
]

// В отличие от эталона, здесь админ-разделы в основной навигации — прячем их у не-админа.
export function getVisibleNavItems(isAdmin: boolean): NavItem[] {
  return isAdmin ? NAV_ITEMS : NAV_ITEMS.filter((i) => !i.to.startsWith('/admin'))
}
